import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Section.css';
import './Registry.css';
import bbbLogo from '../assets/Bed Bath and Beyond.svg';
import airplaneLogo from '../assets/Airplane_silhouette_white.svg';
const bbbLink =
  'https://www.bedbathandbeyond.ca/store/giftregistry/viewregistryguest/547326927';
const airplaneLink =
  'https://www.travelregistry.ca/Registry/Home/Index/JillAndBrycen';

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

const Main = ({ sectionId }) => {
  return (
    <section id={sectionId}>
      <h1>Registry</h1>
      <p className="registry-blurb">
        Your gift to us is coming to our wedding, but if you'd like to get us
        something else, we are registered at Bed Bath and Beyond as well as with
        a honeymoon travel registry for our ski trip to Japan.
      </p>
      <div className="registry-logos">
        <a href={bbbLink} target="_blank" rel="noopener noreferrer">
          <img src={bbbLogo} alt="" />
        </a>
        <a href={airplaneLink} target="_blank" rel="noopener noreferrer">
          <img src={airplaneLogo} alt="" />
          <h3>Travel Registry</h3>
        </a>
      </div>
    </section>
  );
};

class Registry extends Component {
  componentWillMount() {
    this.sectionId = `section-${this.props.section}`;
  }

  render() {
    return <Main {...this.props} sectionId={this.sectionId} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Registry);



// WEBPACK FOOTER //
// ./src/components/Registry.js